module.exports = __webpack_public_path__ + "M1.png?cd3b35b9dcb427bfc4dbc316dedb6b2f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/M1.png
// module id = 298
// module chunks = 0